import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'helpers/verify';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';
import { HeadingTag } from 'components/CmsPage/modules/CmsHeading/CmsHeading';
import { CmsText } from 'components/CmsPage/modules/CmsText/CmsText';

export const SingleOffer = ({ callout, calloutNote, cmsModuleId, details, modules, offer }) => (
  <>
    <header className="SingleOffer__callout">
      <HeadingTag className="SingleOffer__callout-value" title={callout || offer?.callout} />
      <CmsText
        className="SingleOffer__callout-unit"
        cmsModuleId={`ProductCard:Note:${cmsModuleId}`}
        content={calloutNote || offer?.calloutNote}
        shouldIgnoreCache
      />
    </header>
    <div className="SingleOffer__content">
      {!isEmpty(modules) && <CmsModules modules={modules} />}
      {!isEmpty(offer) && (
        <CmsText
          cmsModuleId={`ProductCard:Details:${cmsModuleId}`}
          content={details || offer.details}
          size="medium"
          shouldIgnoreCache
        />
      )}
    </div>
  </>
);

SingleOffer.propTypes = {
  callout: PropTypes.string,
  calloutNote: PropTypes.string,
  cmsModuleId: PropTypes.string,
  details: PropTypes.string,
  modules: PropTypes.arrayOf(PropTypes.shape(CmsModuleShape)),
  offer: PropTypes.object,
};
